<template>
  <transition
    enter-active-class="animated fadeIn"
    leave-active-class="animated fadeOut"
    tag="div"
  >
    <!-- <div class="van-overlay" v-if="dialogState" @click.stop="dialogState = false"> websocket弹窗不让点掉-->
    <div class="van-overlay" v-show="dialogState">
      <div class="van-dialog">
        <p v-if="dialogTitle" class="dialog-header">{{ dialogTitle }}</p>
        <div
          :class="dialogTitle ? 'dialog-body' : 'dialog-content'"
          v-html="$xss(dialogContent)"
        ></div>
        <div class="dialog-footer">
          <span :style="leftBtn.style" @click="leftBtnEvent">{{
            leftBtn.text
          }}</span>
          <span :style="rightBtn.style" @click="rightBtnEvent">{{
            rightBtn.text
          }}</span>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      // 弹出框显示隐藏
      dialogState: false,
      // 标题
      dialogTitle: "标题",
      dialogContent: "弹框内容",
      // 底部左边按钮
      leftBtn: {
        text: "取消",
        style: null,
      },
      // 底部右边按钮
      rightBtn: {
        text: "确定",
        style: null,
      },
    };
  },
  methods: {
    leftBtnEvent() {
      this.dialogState = false;
      this.leftCollback();
    },
    rightBtnEvent() {
      this.dialogState = false;
      this.rightCollback();
    },
    leftCollback() {},
    rightCollback() {},
  },
};
</script>
<style lang="less" scoped>
.animated {
  animation-duration: 0.3s;
}
.van-overlay {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 199;
  .van-dialog {
    background: white;
    border-radius: 0.2rem;
    width: 85%;
    position: absolute;
    top: 50%;
    left: 7.25%;
    font-size: 0.26rem;
    transform: translateY(-50%);
    .dialog-header {
      text-align: center;
      padding-top: 0.5rem;
      font-size: 0.32rem;
    }
    .dialog-body {
      font-size: 0.26rem;
      padding: 0.24rem 0.5rem 0.5rem;
    }
    .dialog-content {
      .dialog-body;
      padding: 0.5rem;
    }
    .dialog-footer {
      display: flex;
      border-top: solid 0.02rem #ebedf0;
      position: relative;
      &::after {
        content: "";
        width: 0.02rem;
        height: 100%;
        background: #ebedf0;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
      span {
        flex: 1;
        height: 0.9rem;
        text-align: center;
        line-height: 0.9rem;
        font-size: 0.3rem;
      }
    }
  }
}
</style>
